// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LocationSharingButton_location-sharing-button__Fk-zG {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  background-color: var(--main-bg-color);
  --main-bg-color: var(--accent-color);
  --hover-bg-color: var(--accent-color-dark);
  --active-bg-color: var(--accent-color-x-dark);
}

.LocationSharingButton_location-sharing-button__Fk-zG:hover {
  background-color: var(--hover-bg-color);
}

.LocationSharingButton_location-sharing-button__Fk-zG:active {
  background-color: var(--active-bg-color);
}

.LocationSharingButton_loading-status__mAnaJ {
  --main-bg-color: rgb(150, 150, 150);
  --hover-bg-color: rgb(150, 150, 150);
  --active-bg-color: rgb(150, 150, 150);
}

.LocationSharingButton_stop-button__GwLA6 {
  --main-bg-color: hsl(0, 100%, 60%);
  --hover-bg-color: hsl(0, 100%, 56%);
  --active-bg-color: hsl(0, 100%, 52%);
}
.LocationSharingButton_stop-button__GwLA6 .LocationSharingButton_icon__lQau5 div:nth-child(1) {
  transform: rotate(45deg);
}
.LocationSharingButton_stop-button__GwLA6 .LocationSharingButton_icon__lQau5 div:nth-child(2) {
  transform: rotate(-45deg);
}

.LocationSharingButton_send-request__eEvt2 .LocationSharingButton_icon__lQau5 div:nth-child(1) {
  transform: rotate(90deg);
}
.LocationSharingButton_stop-button__GwLA6 .LocationSharingButton_icon__lQau5,
.LocationSharingButton_send-request__eEvt2 .LocationSharingButton_icon__lQau5 {
  position: relative;
  width: 16px;
  height: 16px;
  margin-right: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.LocationSharingButton_stop-button__GwLA6 .LocationSharingButton_icon__lQau5 div,
.LocationSharingButton_send-request__eEvt2 .LocationSharingButton_icon__lQau5 div {
  position: absolute;
  background-color: white;
  width: 2px;
  height: 14px;
}`, "",{"version":3,"sources":["webpack://./src/Pages/UserProfile/LocationSharingButton/LocationSharingButton.module.scss"],"names":[],"mappings":"AAAA;EACI,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sCAAA;EACA,oCAAA;EACA,0CAAA;EACA,6CAAA;AACJ;;AAEA;EACI,uCAAA;AACJ;;AAEA;EACI,wCAAA;AACJ;;AAEA;EACI,mCAAA;EACA,oCAAA;EACA,qCAAA;AACJ;;AAQA;EACI,kCAAA;EACA,mCAAA;EACA,oCAAA;AALJ;AAQQ;EACI,wBAAA;AANZ;AASQ;EACI,yBAAA;AAPZ;;AAeQ;EACI,wBAAA;AAZZ;AAqBI;;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AAlBR;AAoBQ;;EACI,kBAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;AAjBZ","sourcesContent":[".location-sharing-button {\n    display: inline-flex;\n    flex-direction: row;\n    align-items: center;\n    background-color: var(--main-bg-color);\n    --main-bg-color: var(--accent-color);\n    --hover-bg-color: var(--accent-color-dark);\n    --active-bg-color: var(--accent-color-x-dark);\n}\n\n.location-sharing-button:hover {\n    background-color: var(--hover-bg-color);\n}\n\n.location-sharing-button:active {\n    background-color: var(--active-bg-color);\n}\n\n.loading-status {\n    --main-bg-color: rgb(150, 150, 150);\n    --hover-bg-color: rgb(150, 150, 150);\n    --active-bg-color: rgb(150, 150, 150);\n}\n\n.cancel-request {\n    // --main-bg-color: hsl(35, 100%, 50%);\n    // --hover-bg-color: hsl(35, 100%, 46%);\n    // --active-bg-color: hsl(35, 100%, 42%);\n}\n\n.stop-button {\n    --main-bg-color: hsl(0, 100%, 60%);\n    --hover-bg-color: hsl(0, 100%, 56%);\n    --active-bg-color: hsl(0, 100%, 52%);\n\n    .icon {\n        div:nth-child(1) {\n            transform: rotate(45deg);\n        }\n\n        div:nth-child(2) {\n            transform: rotate(-45deg);\n        }\n    }\n}\n\n\n.send-request {\n    .icon {\n        div:nth-child(1) {\n            transform: rotate(90deg);\n        }\n\n        div:nth-child(2) {}\n    }\n}\n\n.stop-button,\n.send-request {\n    .icon {\n        position: relative;\n        width: 16px;\n        height: 16px;\n        margin-right: 6px;\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n\n        div {\n            position: absolute;\n            background-color: white;\n            width: 2px;\n            height: 14px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"location-sharing-button": `LocationSharingButton_location-sharing-button__Fk-zG`,
	"loading-status": `LocationSharingButton_loading-status__mAnaJ`,
	"stop-button": `LocationSharingButton_stop-button__GwLA6`,
	"icon": `LocationSharingButton_icon__lQau5`,
	"send-request": `LocationSharingButton_send-request__eEvt2`
};
export default ___CSS_LOADER_EXPORT___;
